// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".select .icon-arrow{transition:transform .3s;margin-left:auto}.select .icon-arrow.opened{transform:rotate(180deg)}.select .icon-arrow path{fill:#838285}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
